module.exports = __webpack_public_path__ + "static/media/karthik-swarnkar-542019-unsplash.2ffb72e0.jpg";